// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"styles__checkboxWrapper___2AxnU","checkboxLabel":"styles__checkboxLabel___2NWks","input":"styles__input___1RqPk"};